import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {actions, Control, Errors} from 'react-redux-form/src';
import MLabelInput from './../components/MLabelInput';
import MInputText from './../components/MInputText';
import AErrorInput from './../components/AErrorInput';
import MErrorGroupInput from './../components/MErrorGroupInput';
import shouldShowErrors from './shouldShowErrors';
import {maxLength, requireString, requireStringWithFormat} from './validators';
import {i18nInterface} from 'utilities/i18n_common';
import get from 'lodash/get';
import pick from 'lodash/pick';
import {connect} from 'react-redux';

export const addressValidators = {
  street: {
    required: requireString,
    maxLength: maxLength.bind(null, 30),
  },
  number: {
    required: requireString,
    format: requireStringWithFormat.bind(null, /^.*[0-9].*$/),
    maxLength: maxLength.bind(null, 5),
  },
  zip: {
    required: requireString,
    format: requireStringWithFormat.bind(null, /^[0-9]{5}$/),
  },
  city: {
    required: requireString,
    maxLength: maxLength.bind(null, 25),
  },
};

function mapDispatchToProps(dispatch, ownProps) {
  const {
    model,
  } = ownProps;

  return {
    updateStore: function(values) {
      for (const subModel in values) {
        const modelKey = `${model}.${subModel}`;
        // emit change action
        dispatch(
            actions.change(
                modelKey,
                values[subModel]
            )
        );
        // emit validate action
        dispatch(
            actions.validate(
                modelKey,
                addressValidators[subModel]
            )
        );

        // set touched to show inline validation
        dispatch(
            actions.setTouched(modelKey)
        );
      }
    },
  };
}

function mapStateToProps(state, ownProps) {
  const {
    model,
  } = ownProps;

  const candidates = pick(
      get(state, model),
      ['street', 'number', 'city', 'zip']
  );
  let storeHasValues = ownProps.optionalAutocomplete || false;

  for (const i in candidates ) {
    if ( candidates[i] !== '' && candidates[i] != null ) {
      storeHasValues = true;
      break;
    }
  }

  return {
    optionalAutocomplete: storeHasValues,
  };
}


/**
 * OInputFieldAddress - …
 **/
class OInputFieldAddress extends Component {
  constructor(props) {
    super(props);

    this.mapProps = {
      error: (props) => this.handleMapPropError(props),
    };
  }

  componentDidMount() {
    const {
      useAutocomplete,
      model,
    } = this.props;

    if ( useAutocomplete ) {
      const selfComponent = this;
      const initAsync = () => {
        if ( window && get(window, 'google.maps.places.Autocomplete') ) {
          // TODO restrict autocomplete to https://de.wikipedia.org/wiki/Liste_der_Extrempunkte_Deutschlands
          selfComponent.autocompleter = new google.maps.places.Autocomplete(
              document.getElementById(`${model}.street`),
              {
                types: ['geocode'],
                componentRestrictions: {country: ['de']},
              }
          );
          const callbackFn = selfComponent.autocompleteSelect.bind(selfComponent);
          selfComponent.autocompleter.addListener('place_changed', callbackFn);
        } else {
          setTimeout(initAsync, 200);
        }
      };
      setTimeout(initAsync, 400);
    }
  }

  autocompleteSelect() {
    const {
      useAutocomplete,
      model,
      updateStore,
    } = this.props;

    const loadedPlace = this.autocompleter.getPlace();
    const autocompleteValues = {};
    for (let i = 0; i < loadedPlace.address_components.length; i++) {
      const types = loadedPlace.address_components[i].types;
      const value = loadedPlace.address_components[i].long_name;
      if ( types.indexOf('route') > -1 ) {
        autocompleteValues['street'] = value;
      }
      if ( types.indexOf('street_number') > -1 ) {
        autocompleteValues['number'] = value;
      }
      if ( types.indexOf('locality') > -1 ) {
        autocompleteValues['city'] = value;
      }
      if ( types.indexOf('postal_code') > -1 ) {
        autocompleteValues['zip'] = value;
      }
    }
    // set controlled by external API value of field to be empty again
    document &&
    document.getElementById(`${model}.street`) &&
    (document.getElementById(`${model}.street`).value = '');

    // update values on store
    updateStore(autocompleteValues);
  }

  render() {
    const {
      messages,
      labels,
      useAutocomplete,
      model,
      optionalAutocomplete,
      autoComplete,
    } = this.props;

    const streetEl = this.renderInputField(
        'street', // subModel
        labels.street, // label
        messages.street, // messages
        addressValidators.street // validators
    );

    const numberEl = this.renderInputField(
        'number', // subModel
        labels.number, // label
        messages.number, // messages
        addressValidators.number // validators
    );

    const zipEl = this.renderInputField(
        'zip', // subModel
        labels.zip, // label
        messages.zip, // messages
        addressValidators.zip // validators
    );

    const cityEl = this.renderInputField(
        'city', // subModel
        labels.city, // label
        messages.city, // messages
        addressValidators.city // validators
    );


    const hideOnAutocompleterActive =
        (useAutocomplete && !optionalAutocomplete) ? 'hidden' : '';

    document.getElementById('checkout.landlord.address.street') ? document.getElementById(
        'checkout.landlord.address.street').autocomplete = 'landlordAddress' : null;

    return (
      <div className="o-input-field o-input-field-address">
        <div className={'o-input-field-address__first-row' + ' ' + hideOnAutocompleterActive}>
          {streetEl}
          {numberEl}
        </div>
        <div className={'o-input-field-address__second-row' + ' ' + hideOnAutocompleterActive}>
          {zipEl}
          {cityEl}
        </div>
        <div className="clearfix"/>
      </div>
    );
  }


  renderInputField(subModel, label, messages, validators) {
    const {
      model,
      validateOn,
      showErrors,
      disabled,
      onChangeSubfield,
      autoComplete,
    } = this.props;

    const deepModel = `${model}.${subModel}`;

    let typeProps = {
      id: deepModel,
      type: 'text',
    };

    if (subModel === 'street') {
      typeProps = {
        id: deepModel,
        placeholder: 'Musterstraße',
      };
    }

    if (subModel === 'number') {
      let streetPlaceholder = 1;

      if (model.includes('secondTenant')) {
        streetPlaceholder = 2;
      }

      if (model.includes('landlord')) {
        streetPlaceholder = 3;
      }

      if (model.includes('object')) {
        streetPlaceholder = 4;
      }

      typeProps = {
        id: deepModel,
        placeholder: streetPlaceholder,
      };
    }

    if (subModel === 'zip') {
      typeProps = {
        id: deepModel,
        placeholder: '12345',
        type: 'number',
        max: '99999',
        onKeyPress: (e) => {
          if ( e.charCode >= 48 && e.charCode <= 57 && e.target.value.length > 4 ) {
            e.stopPropagation();
            e.preventDefault();
          }
        },
      };
    }

    if (subModel === 'city') {
      typeProps = {
        id: deepModel,
        placeholder: 'Musterstadt',
      };
    }


    return (
      <div onChange={onChangeSubfield} className={`o-input-field-address__${subModel}`}>
        <MLabelInput
          htmlFor={deepModel}
          label={label}
          disabled={disabled}
        />
        <Control.text
          {...typeProps}
          model={deepModel}
          component={MInputText}
          validators={validators}
          validateOn={validateOn}
          withFieldValue={true}
          showErrors={showErrors} // forces rerender when a value change - needed
          controlProps={{
            disabled,
            autoComplete,
          }}
          mapProps={this.mapProps}
        />
        <Errors
          model={deepModel}
          messages={messages}
          wrapper={MErrorGroupInput}
          component={AErrorInput}
          show={showErrors}
        />
      </div>
    );
  }

  handleMapPropError(props) {
    const {showErrors} = this.props;
    return shouldShowErrors(showErrors, props);
  }

  // handleMapPropModelValue = (props) => props.modelValue
}

const propTypesMessages = PropTypes.shape({
  required: PropTypes.string.isRequired,
});


OInputFieldAddress.propTypes = {
  /**
   * react-redux-form model
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
   */
  model: PropTypes.string.isRequired,
  /**
   * disable the input
   */
  disabled: PropTypes.bool,
  /**
   * when validation should be fired
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
   */
  validateOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /**
   * error messages for required validation
   * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
   */
  messages: PropTypes.shape({
    street: propTypesMessages,
    number: propTypesMessages,
    zip: propTypesMessages,
    city: propTypesMessages,
  }).isRequired,
  /**
   * when errors should be shown
   * function which gets passed the props of the form-model
   * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
   */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
   * label and children are the same
   */
  labels: PropTypes.shape({
    street: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
  }).isRequired,
  /**
   * Callback to be evaluated if any field changes (street, streetnumber, zip, city)
   */
  onChangeSubfield: PropTypes.func,
  /**
   * Use autocompleter from Google
   * external API:
   * https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform?hl=de
   */
  useAutocomplete: PropTypes.bool,
  /**
   * prop is true if autocomplete should be shown next to regular input fields
   */
  optionalAutocomplete: PropTypes.bool,
  /**
   * updateStore dispatches with data-param to be changed on store
   * passed from connect() mapDispatchToProps
   */
  updateStore: PropTypes.func,
};
OInputFieldAddress.defaultProps = {
  validateOn: 'blur',
  messages: {
    street: {
      required: i18nInterface('error.missing.address.street'),
      maxLength: i18nInterface('error.length.max30'),
    },
    number: {
      required: i18nInterface('error.missing.address.number'),
      format: i18nInterface('error.format.address.number'),
      maxLength: i18nInterface('error.length.max5'),
    },
    zip: {
      required: i18nInterface('error.missing.address.zip'),
      format: i18nInterface('error.format.address.zip'),
    },
    city: {
      required: i18nInterface('error.missing.address.city'),
      maxLength: i18nInterface('error.length.max25'),
    },
  },
  labels: {
    street: i18nInterface('label.address.street'),
    number: i18nInterface('label.address.number'),
    zip: i18nInterface('label.address.zip'),
    city: i18nInterface('label.address.city'),
  },
  useAutocomplete: false,
  optionalAutocomplete: false,
};
export default connect(mapStateToProps, mapDispatchToProps)(OInputFieldAddress);

